import {Component, OnInit} from '@angular/core';
import {MediaObserver} from '@angular/flex-layout';

@Component({
  selector: 'longmoon-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  url = '';
  starryNightOpen = false;

  constructor(
    public mo: MediaObserver,
  ) {
  }

  ngOnInit(): void {
  }

  toggleStarryNight(): void {
    this.starryNightOpen = !this.starryNightOpen;
  }
}
